export const theme = {
	color: {
		black: "#000000",
		whisper: "#F5F5FA",
		woodsmoke: "#18181B",
		white: "#FFFFFF",
		waterloo: "#7E839A",
		mystic: "#E4E6F0",
		silver: "#C4C4C4",
		pattensBlue: "#D6E4FF",
		stormGray: "#74788B",
		scienceBlue: "#0044CC",
	},

	breakpoints: {
		smallMobile: "420px",
		smallerMobile: "676px",
		mobile: "767px",
		tablet: "1140px",
		narrow: "1520px",
	},
};